import axios from 'axios';
import i18n from 'i18next';
import { logout } from 'modules/auth/slice';
import { getAuthority } from 'modules/auth/slice';
import { passwordExpired } from 'modules/auth/slice';
import { clearData as cleanCargoTraceSearch } from 'modules/cargo-trace-search/slice';
import { cleanStore as cleanCommon } from 'modules/common/slice';
import { store } from 'redux/configStore';

import showMessage from '../components/Message';

import { MessageType, STATUS_HTTPS, TYPE_OF_ANT_DESIGN } from './constant';

const HEADERS: any = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
};

const HEADERS_MULTIPLE_PART = {
  ...HEADERS,
  'Content-Type': 'multipart/form-data; boundary=something',
  Accept: 'application/json',
};

export const getToken = (token: any): any => {
  HEADERS['Authorization'] = `Bearer ${token}`;
  HEADERS_MULTIPLE_PART['Authorization'] = `Bearer ${token}`;
};

const getFullUrl = (url: string) => {
  if (url.startsWith('http')) {
    return url;
  }
  // if (!url.startsWith('/')) {
  //   url = '/' + url;
  // }
  return `${process.env.REACT_APP_API_URL}` + url;
};

export const throttledResetToLogin = () => {
  store.dispatch(logout());
  store.dispatch(cleanCargoTraceSearch());
  store.dispatch(cleanCommon());
};

const handleSuccess = (response: any) => {
  if (response.code) {
    showMessage(TYPE_OF_ANT_DESIGN.SUCCESS, i18n.t(`message.${response?.code}`));
  }

  return response;
};

export const handleError = (err?: any) => {
  const extraInfo = err?.response?.data?.extraInfo;
  const isExtraInfo = extraInfo && !!Object.keys(extraInfo).length;

  if ((err?.toJSON() && err.toJSON().msg === 'Network Error') || err?.message === 'Network Error') {
    return showMessage(TYPE_OF_ANT_DESIGN.ERROR, 'message.common.0003');
  }

  if (err.response.status === STATUS_HTTPS.UNAUTHENTICATED) {
    throttledResetToLogin();
    throw new Error('401');
  }

  if (err.response.status === STATUS_HTTPS.FORBIDDEN) {
    showMessage(TYPE_OF_ANT_DESIGN.ERROR, 'message.common.0005');
    throw new Error(i18n.t('message.common.0005'));
  }

  if (err.response.status >= 500) {
    throw new Error('Server Error'); // TODO update
  }

  if (err.response.status === STATUS_HTTPS.FORBIDDEN) {
    store.dispatch(getAuthority());
    return showMessage(TYPE_OF_ANT_DESIGN.ERROR, `${err?.response?.data?.message}`);
  }

  if (isExtraInfo) {
    // パスワード期限切れ警告の場合、次リクエストでログイン可能とするためセレクターに情報を保存する
    if (err?.response?.data?.message === 'login.0005') {
      store.dispatch(passwordExpired());
      showMessage(TYPE_OF_ANT_DESIGN.ERROR, i18n.t(`message.${err?.response?.data?.message}`, { time: extraInfo }));
      throw new Error(err.response.data.message);
    }
    showMessage(TYPE_OF_ANT_DESIGN.ERROR, i18n.t(`message.${err?.response?.data?.message}`, { time: extraInfo }));
  }

  if (err.response && !err.response.data.errorType) {
    if (err?.response.data.message.startsWith('Disp')) {
      showMessage(TYPE_OF_ANT_DESIGN.ERROR, `${err?.response.data.message}`);
      throw new Error(err.response.data.message);
    }
    if (err?.response.data.maxValue) {
      showMessage(
        TYPE_OF_ANT_DESIGN.ERROR,
        i18n.t(`message.${err?.response.data.message}`, { maxValue: err?.response.data.maxValue })
      );
    } else {
      showMessage(
        TYPE_OF_ANT_DESIGN.ERROR,
        err.response.data.messageType === MessageType.STRING
          ? err?.response.data.message
          : `message.${err?.response.data.message}`
      );
    }
  } else {
    showMessage(TYPE_OF_ANT_DESIGN.ERROR, `${err?.response.data.message}`);
  }

  throw new Error(err.response.data.message); // TODO update
};

const api = {
  get: (endpoint: string, params = {}) => {
    console.log('*****GET', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, params);
    return axios
      .get(getFullUrl(endpoint), {
        params: params,
        headers: HEADERS,
      })
      .then((json) => handleSuccess(json.data))
      .catch((err) => {
        console.log('****ERROR GET*****', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, err);
        handleError(err);
      });
  },

  post: (endpoint: string, params?: any) => {
    console.log('*****POST', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, params);
    return axios
      .post(getFullUrl(endpoint), params, {
        headers: HEADERS,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR POST*****', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, err);
        handleError(err);
      });
  },

  postMultiplePart: (endpoint: string, params: any) => {
    console.log('*****POST MULTIPLEPART', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, params);
    return axios
      .post(getFullUrl(endpoint), params, {
        headers: HEADERS_MULTIPLE_PART,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR POSTMULTIPLEPART*****', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, err);
        handleError(err);
      });
  },

  put: (endpoint: string, params?: any) => {
    console.log('*****PUT', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, params);
    return axios
      .put(getFullUrl(endpoint), params, {
        headers: HEADERS,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR PUT*****', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, err);
        handleError(err);
      });
  },

  patch: (endpoint: string, params?: any) => {
    console.log('*****PATCH', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, params);
    return axios
      .patch(getFullUrl(endpoint), params, {
        headers: HEADERS,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR PATCH*****', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, err);
        handleError(err);
      });
  },

  delete: (endpoint: string, params: any) => {
    console.log('*****DELETE', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, params);
    return axios
      .delete(getFullUrl(endpoint), {
        params: params,
        headers: HEADERS,
      })
      .then((json) => json.data)
      .catch((err) => {
        console.log('****ERROR DELETE*****', `${process.env.REACT_APP_API_URL}/api/${endpoint}`, err);
        handleError(err);
      });
  },
};

export default api;
